/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from '../../../assets/animations/gray-load.json';
import { Breakpoints, ContainersWidth } from '../../../styles/Grid/GridSizes';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Icon } from '../../ui/Icon';
import { Picture } from '../../ui/Picture';

import DotComponent from '../../ui/DotComponent';
import * as styles from './index.style';

import { Column, Container, Row } from '../../../styles/Grid';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
// import Slider from './Slider';
import Spacer from '../../ui/Spacer';

import defaultData from './data.json';
import { compose } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import { get } from 'lodash';

import FeatureBulletLink from '../FeatureBulletLink';

class FeatureContentBlockWithBg extends SafePureComponent {
  safeRender() {
    // const fields = defaultsDeep(this.props.fields, defaultData);
    const { fields } = this.props;
    const ComponentList = get(fields, 'ComponentList', []);
    // const style = "TextImage";

    return (
      <Spacer customCss={styles.containerSizesShop}>
        <Container css={[styles.itemsContainerCss]}>
          {ComponentList.map(item => {
            return <FeatureBulletLink key={item.id} data={item.fields} />;
          })}
        </Container>
      </Spacer>
    );
  }
}

FeatureContentBlockWithBg.displayName = 'Feature/ContentBlockWithBg';

FeatureContentBlockWithBg.defaultProps = {
  fields: defaultData,
};

export default compose(withNamespaces())(FeatureContentBlockWithBg);
